import BasicInfoSection from './BasicInfoSection';
import { BasicInfoSectionProps, BasicInfoSectionValueProps } from './types';

export type { BasicInfoSectionProps, BasicInfoSectionValueProps };
export default BasicInfoSection;
